import { Action, createReducer, on } from "@ngrx/store";
import { CheckoutActions } from "../actions";
import { CheckoutBillingAddressState } from "../checkout.state";
import { OrderType } from "../../models/checkout.model";

const initialState: CheckoutBillingAddressState = {
    loading: null,
    success: null,
    error: null,
    orderType: null,
    cartGroupData: null,
    legalEntityObj: null,
    addressData: null,
    companyNameFlag: null,
};

const checkoutBillingAddressReducer = createReducer(
    initialState,
    on(
        CheckoutActions.loadBillingAddressRequest,
        (state: CheckoutBillingAddressState, { legalEntity, address, flag }) => ({
            ...state,
            loading: null,
            success: true,
            error: null,
            orderType: OrderType.REQUEST,
            legalEntityObj: legalEntity,
            addressData: address,
            companyNameFlag: flag
        })
    ),
    on(
        CheckoutActions.loadBillingAddressApprove,
        (state: CheckoutBillingAddressState) => ({
            ...state,
            loading: true,
            success: null,
            error: null,
            orderType: OrderType.APPROVE,
        })
    ),
    on(
        CheckoutActions.loadBillingAddressApproveSuccess,
        (state: CheckoutBillingAddressState, { payload }) => {
            const cartsVal = payload?.carts?.at(0);
            const legalEntityVal = cartsVal?.legalEntity;
            const addressVal = legalEntityVal?.addresses?.addresses.find((val) => val.billingAddress === true);

            return {
                ...state,
                loading: null,
                success: true,
                error: null,
                cartGroupData: payload,
                legalEntityObj: legalEntityVal,
                addressData: addressVal,
                companyNameFlag: !(addressVal?.companyName)
            }
        }
    ),
    on(
        CheckoutActions.loadBillingAddressApproveFail,
        (state: CheckoutBillingAddressState, { payload }) => ({
            ...state,
            loading: null,
            success: null,
            error: payload,
        })
    ),
    on(
        CheckoutActions.clearCheckoutState,
        () => ({ ...initialState })
    )
);

export function reducer(state: CheckoutBillingAddressState | undefined, action: Action) {
    return checkoutBillingAddressReducer(state, action);
}